import {
  LOGGED_IN_USER_LS_KEY,
  REDIRECT_URL_LS_KEY,
  REDIRECT_URL_LS_KEY_VITE,
} from '../constants/authConstants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setUser = (user: any) => {
  if (typeof window === 'undefined' || !sessionStorage) return;

  let formattedUser = user;

  if (typeof user !== 'string') {
    formattedUser = JSON.stringify(user);
  }

  try {
    localStorage.setItem(LOGGED_IN_USER_LS_KEY, formattedUser);
  } catch (error) {
    console.error('User local storage save error. ', error);
  }
};

export const getUser = () => {
  if (typeof window === 'undefined' || !localStorage) return;

  const localStorageValue: string | null = localStorage.getItem(
    LOGGED_IN_USER_LS_KEY,
  );

  if (!localStorageValue) return;

  try {
    const parsedCookieValue = JSON.parse(localStorageValue);

    if (parsedCookieValue) {
      return parsedCookieValue;
    }
  } catch (error) {
    console.error('User local storage parse error. ', error);
  }
};

export const removeUser = () => {
  if (typeof window === 'undefined' || !localStorage) return;

  try {
    localStorage.removeItem(LOGGED_IN_USER_LS_KEY);
  } catch (error) {
    console.error('User local storage remove error. ', error);
  }
};

export const setRedirectUrl = async (url: string) => {
  if (typeof window === 'undefined' || !sessionStorage) return;

  try {
    localStorage.setItem(REDIRECT_URL_LS_KEY, url);
  } catch (error) {
    return null;
  }
};

export const getRedirectUrl = () => {
  if (typeof window === 'undefined' || !localStorage) return;

  const localStorageValue: string | null =
    localStorage.getItem(REDIRECT_URL_LS_KEY);

  return localStorageValue;
};

export const removeRedirectUrl = () => {
  if (typeof window === 'undefined' || !localStorage) return;

  try {
    localStorage.removeItem(REDIRECT_URL_LS_KEY);
    localStorage.removeItem(REDIRECT_URL_LS_KEY_VITE);
  } catch (error) {
    return null;
  }
};
